module.exports = __webpack_public_path__ + "img/falling-into-deep-sleep.44d4708b.png";